
/* injects from baggage-loader */
require('./vehicle-select-modal.component.html');

import angular from 'angular';

angular.module('AaApp.Opp').component('vehicleSelectModal', {
    templateUrl: '/app/components/deal-sheet/modals/vehicle-select-modal.component.html',
    bindings: {
        resolve: '<',
        close: '&',
        dismiss: '&'
    }
});
